export const getSettingsStyles = ({ theme, isMobile, isRTL }) => ({
  container: {
    marginTop: "-25px",
    direction: isRTL ? "rtl" : "ltr",
  },
  header: {
    background:
      theme === "light"
        ? "linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(249, 250, 251, 0.95) 100%)"
        : "linear-gradient(135deg, rgba(30, 41, 59, 0.01) 0%, rgba(15, 23, 42, 0.01) 100%)",
    border:
      theme === "light"
        ? "1px solid rgba(226, 232, 240, 0.8)"
        : "1px solid rgba(71, 85, 105, 0.4)",
    borderRadius: isMobile ? "20px" : "28px",
    padding: isMobile ? "24px" : "40px",
    marginBottom: isMobile ? "20px" : "32px",
    backdropFilter: "blur(24px)",
    boxShadow:
      theme === "light"
        ? "0 20px 40px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.02)"
        : "0 20px 40px -12px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.05)",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: isMobile ? "column" : "row",
    gap: isMobile ? "20px" : "0",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: isMobile ? "16px" : "24px",
    flexDirection: isMobile ? "column" : "row",
  },
  iconWrapper: {
    width: isMobile ? "56px" : "72px",
    height: isMobile ? "56px" : "72px",
    borderRadius: isMobile ? "16px" : "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #2e7cba 0%, #2e7cba 100%)",
    transition: "all 0.3s ease",
  },
  titleWrapper: {
    textAlign: isMobile ? "center" : isRTL ? "right" : "left",
  },
  title: {
    fontSize: isMobile ? "26px" : "36px",
    fontWeight: "800",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    margin: "0 0 8px 0",
    letterSpacing: "-0.02em",
  },
  subtitle: {
    fontSize: isMobile ? "13px" : "15px",
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.7)",
    margin: 0,
    fontWeight: "500",
  },
  settingsGrid: {
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(420px, 1fr))",
    gap: isMobile ? "18px" : "28px",
    marginBottom: isMobile ? "40px" : "60px",
  },
  card: {
    background:
      theme === "light"
        ? "rgba(255, 255, 255, 0.95)"
        : "rgba(30, 41, 59, 0.01)",
    border:
      theme === "light"
        ? "1px solid rgba(226, 232, 240, 0.8)"
        : "1px solid rgba(71, 85, 105, 0.4)",
    borderRadius: isMobile ? "18px" : "24px",
    padding: isMobile ? "22px" : "32px",
    backdropFilter: "blur(24px)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    overflow: "hidden",
  },
  cardHeader: {
    marginBottom: isMobile ? "20px" : "28px",
    paddingBottom: isMobile ? "16px" : "24px",
    borderBottom:
      theme === "light"
        ? "2px solid rgba(226, 232, 240, 0.6)"
        : "2px solid rgba(71, 85, 105, 0.3)",
  },
  cardTitle: {
    display: "flex",
    alignItems: "center",
    gap: isMobile ? "10px" : "14px",
    fontSize: isMobile ? "18px" : "22px",
    fontWeight: "700",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    margin: "0 0 10px 0",
    letterSpacing: "-0.01em",
  },
  cardDescription: {
    fontSize: isMobile ? "13px" : "14px",
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.7)",
    margin: 0,
    lineHeight: "1.6",
    fontWeight: "500",
  },
  settingGroup: {
    display: "flex",
    flexDirection: "column",
    gap: isMobile ? "20px" : "24px",
  },
  settingItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: isMobile ? "flex-start" : "center",
    gap: isMobile ? "14px" : "20px",
    flexDirection: isMobile ? "column" : "row",
    padding: isMobile ? "12px 0" : "16px 0",
    borderBottom:
      theme === "light"
        ? "1px solid rgba(226, 232, 240, 0.4)"
        : "1px solid rgba(71, 85, 105, 0.2)",
  },
  toggleItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: isMobile ? "flex-start" : "center",
    gap: isMobile ? "14px" : "20px",
    padding: isMobile ? "12px 0" : "16px 0",
    flexDirection: isMobile ? "column" : "row",
    borderBottom:
      theme === "light"
        ? "1px solid rgba(226, 232, 240, 0.4)"
        : "1px solid rgba(71, 85, 105, 0.2)",
  },
  settingLabel: {
    flex: 1,
    display: "flex",
    alignItems: "flex-start",
    gap: isMobile ? "10px" : "14px",
    cursor: "pointer",
    color: theme === "light" ? "#0f172a" : "#ffffff",
  },
  labelContent: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    flex: 1,
  },
  labelTitle: {
    fontSize: isMobile ? "14px" : "15px",
    fontWeight: "600",
    color: theme === "light" ? "#1e293b" : "#ffffff",
    letterSpacing: "-0.01em",
  },
  labelDescription: {
    fontSize: isMobile ? "12px" : "13px",
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
    fontWeight: "500",
    lineHeight: "1.5",
  },
  selectWrapper: {
    position: "relative",
    minWidth: isMobile ? "100%" : "200px",
  },
  select: {
    width: "100%",
    padding: isMobile ? "16px 44px 16px 18px" : "14px 44px 14px 20px",
    paddingRight: isRTL ? "20px" : "44px",
    paddingLeft: isRTL ? "44px" : "20px",
    borderRadius: "16px",
    border:
      theme === "light"
        ? "2px solid rgba(148, 163, 184, 0.2)"
        : "2px solid rgba(100, 116, 139, 0.3)",
    background:
      theme === "light"
        ? "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)"
        : "linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(15, 23, 42, 0.95) 100%)",
    color: theme === "light" ? "#1e293b" : "#f1f5f9",
    fontSize: isMobile ? "15px" : "16px",
    fontWeight: "600",
    outline: "none",
    transition: "all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
    cursor: "pointer",
    appearance: "none",
    boxShadow:
      theme === "light"
        ? "0 4px 16px rgba(148, 163, 184, 0.12), 0 0 0 1px rgba(148, 163, 184, 0.06)"
        : "0 4px 20px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(100, 116, 139, 0.3)",
    backdropFilter: theme === "dark" ? "blur(12px)" : "none",
    WebkitBackdropFilter: theme === "dark" ? "blur(12px)" : "none",
  },
  selectIcon: {
    position: "absolute",
    right: isRTL ? "auto" : "14px",
    left: isRTL ? "14px" : "auto",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
  },
  themeToggle: {
    display: "flex",
    background:
      theme === "light"
        ? "rgba(241, 245, 249, 0.8)"
        : "rgba(15, 23, 42, 0.6)",
    borderRadius: "16px",
    padding: "6px",
    border:
      theme === "light"
        ? "2px solid rgba(226, 232, 240, 0.8)"
        : "2px solid rgba(71, 85, 105, 0.4)",
    width: isMobile ? "100%" : "auto",
  },
  themeButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: isMobile ? "8px" : "10px",
    padding: isMobile ? "12px 16px" : "10px 20px",
    borderRadius: "12px",
    border: "none",
    background: "transparent",
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    fontSize: isMobile ? "13px" : "14px",
    fontWeight: "600",
    flex: isMobile ? 1 : "none",
    letterSpacing: "-0.01em",
  },
  themeButtonActive: {
    background: "linear-gradient(135deg, #2e7cba 0%, #2e7cba 100%)",
    color: "#ffffff",
  },
  logoutModal: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0, 0, 0, 0.85)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    backdropFilter: "blur(10px)",
    padding: isMobile ? "20px" : "40px",
  },
  logoutModalContent: {
    background:
      theme === "light"
        ? "linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(249, 250, 251, 0.98) 100%)"
        : "linear-gradient(135deg, rgba(30, 41, 59, 0.98) 0%, rgba(15, 23, 42, 0.98) 100%)",
    border:
      theme === "light"
        ? "2px solid rgba(226, 232, 240, 0.8)"
        : "2px solid rgba(71, 85, 105, 0.4)",
    borderRadius: isMobile ? "20px" : "28px",
    padding: isMobile ? "24px" : "40px",
    maxWidth: "600px",
    width: "100%",
    backdropFilter: "blur(24px)",
    boxShadow:
      theme === "light"
        ? "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
        : "0 25px 50px -12px rgba(0, 0, 0, 0.7)",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  modalActions: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    flexDirection: isMobile ? "column" : "row",
  },
  confirmButton: {
    background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
    color: "white",
    border: "none",
    borderRadius: "14px",
    padding: isMobile ? "14px 28px" : "12px 32px",
    fontWeight: "700",
    fontSize: isMobile ? "15px" : "16px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    flex: isMobile ? "none" : 1,
  },
  cancelButton: {
    background:
      theme === "light"
        ? "rgba(226, 232, 240, 0.8)"
        : "rgba(71, 85, 105, 0.5)",
    color: theme === "light" ? "#1e293b" : "#ffffff",
    border: "none",
    borderRadius: "14px",
    padding: isMobile ? "14px 28px" : "12px 32px",
    fontWeight: "700",
    fontSize: isMobile ? "15px" : "16px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    flex: isMobile ? "none" : 1,
  },
  logoutButton: {
    background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
    color: "white",
    border: "none",
    borderRadius: isMobile ? "16px" : "18px",
    padding: isMobile ? "16px 24px" : "18px 32px",
    fontWeight: "700",
    fontSize: isMobile ? "15px" : "16px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    letterSpacing: "-0.01em",
    width: isMobile ? "100%" : "auto",
    minWidth: isMobile ? "auto" : "180px",
  },
  logoutCard: {
    background:
      theme === "light"
        ? "linear-gradient(135deg, rgba(254, 242, 242, 0.95) 0%, rgba(254, 226, 226, 0.95) 100%)"
        : "linear-gradient(135deg, rgba(127, 29, 29, 0.2) 0%, rgba(153, 27, 27, 0.2) 100%)",
    border:
      theme === "light"
        ? "2px solid rgba(239, 68, 68, 0.2)"
        : "2px solid rgba(239, 68, 68, 0.3)",
    borderRadius: isMobile ? "18px" : "24px",
    padding: isMobile ? "28px" : "36px",
    backdropFilter: "blur(24px)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: isMobile ? "20px" : "24px",
  },
  logoutCardTitle: {
    fontSize: isMobile ? "18px" : "20px",
    fontWeight: "700",
    color: theme === "light" ? "#dc2626" : "#fca5a5",
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    justifyContent: "center",
  },
  logoutCardDescription: {
    fontSize: isMobile ? "13px" : "14px",
    color: theme === "light" ? "#991b1b" : "rgba(252, 165, 165, 0.8)",
    margin: 0,
    lineHeight: "1.6",
    fontWeight: "500",
  },
  toggle: {
    width: isMobile ? "50px" : "54px",
    height: isMobile ? "26px" : "28px",
    borderRadius: "14px",
    background:
      theme === "light"
        ? "rgba(203, 213, 225, 0.8)"
        : "rgba(71, 85, 105, 0.5)",
    position: "relative",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    alignSelf: isMobile ? "flex-end" : "center",
    border:
      theme === "light"
        ? "2px solid rgba(226, 232, 240, 0.6)"
        : "2px solid rgba(71, 85, 105, 0.4)",
    boxShadow:
      theme === "light"
        ? "inset 0 2px 4px rgba(0, 0, 0, 0.08)"
        : "inset 0 2px 4px rgba(0, 0, 0, 0.3)",
  },
  toggleActive: {
    background: "linear-gradient(135deg, #667eea 0%, #2e7cba 100%)",
    borderColor: "#667eea",
    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
  },
  toggleSlider: {
    width: isMobile ? "20px" : "22px",
    height: isMobile ? "20px" : "22px",
    borderRadius: "50%",
    background: "#ffffff",
    position: "absolute",
    top: "50%",
    left: "3px",
    transform: "translateY(-50%)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
  },
  toggleSliderActive: {
    transform: isMobile ? "translate(24px, -50%)" : "translate(26px, -50%)",
  },
  // ── Change Password modal ──────────────────────────────────────────────
  // `direction` is set on the overlay itself so the dialog mirrors correctly
  // no matter where it ends up in the tree; everything inside then uses
  // logical properties (start/end) instead of hard-coded left/right.
  passwordModalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(2, 6, 23, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    backdropFilter: "blur(8px)",
    padding: isMobile ? "16px" : "10px",
    overflowY: "auto",
    // Scrollable, but the bar itself stays hidden — the WebKit half is done
    // with a ::-webkit-scrollbar rule on .settings-password-modal-scroll,
    // which can't be expressed as an inline style.
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    direction: isRTL ? "rtl" : "ltr",
  },
  passwordModalCard: {
    background:
      theme === "light"
        ? "linear-gradient(135deg, rgba(255, 255, 255, 0.99) 0%, rgba(248, 250, 252, 0.99) 100%)"
        : "linear-gradient(135deg, rgba(30, 41, 59, 0.99) 0%, rgba(15, 23, 42, 0.99) 100%)",
    border:
      theme === "light"
        ? "1px solid rgba(226, 232, 240, 0.9)"
        : "1px solid rgba(71, 85, 105, 0.5)",
    borderRadius: isMobile ? "20px" : "24px",
    padding: isMobile ? "24px" : "32px",
    maxWidth: "520px",
    width: "100%",
    maxHeight: "100%",
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    boxShadow:
      theme === "light"
        ? "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
        : "0 25px 50px -12px rgba(0, 0, 0, 0.7)",
    display: "flex",
    flexDirection: "column",
    gap: "22px",
    position: "relative",
    textAlign: "start",
  },
  passwordModalHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: "14px",
  },
  passwordModalBadge: {
    width: "44px",
    height: "44px",
    borderRadius: "14px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #2e7cba 0%, #1a5c8c 100%)",
    color: "#ffffff",
  },
  passwordModalTitle: {
    fontSize: isMobile ? "18px" : "21px",
    fontWeight: "800",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    margin: "0 0 4px 0",
  },
  passwordModalSubtitle: {
    fontSize: "13px",
    lineHeight: 1.6,
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.65)",
    margin: 0,
  },
  passwordModalClose: {
    position: "absolute",
    insetInlineEnd: isMobile ? "16px" : "20px",
    insetBlockStart: isMobile ? "16px" : "20px",
    width: "32px",
    height: "32px",
    borderRadius: "10px",
    border: "none",
    background:
      theme === "light" ? "rgba(226, 232, 240, 0.7)" : "rgba(71, 85, 105, 0.45)",
    color: theme === "light" ? "#475569" : "rgba(255, 255, 255, 0.8)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "opacity 0.2s ease",
  },
  passwordModalActions: {
    display: "flex",
    gap: "12px",
    marginTop: "4px",
    flexDirection: isMobile ? "column-reverse" : "row",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
  },
  inputLabel: {
    fontSize: isMobile ? "13px" : "14px",
    fontWeight: "600",
    color: theme === "light" ? "#475569" : "rgba(255, 255, 255, 0.8)",
    // `text-align: start` follows the inherited direction, so RTL needs no flip.
    textAlign: "start",
  },
  inputWrapper: {
    position: "relative",
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  input: {
    width: "100%",
    // Logical padding: `inline-start` is the left in LTR and the right in RTL,
    // so the lock and eye icons stay on the correct sides in both languages.
    padding: isMobile ? "14px 16px" : "12px 16px",
    paddingInlineStart: "44px",
    paddingInlineEnd: "44px",
    borderRadius: "12px",
    border:
      theme === "light"
        ? "1px solid rgba(148, 163, 184, 0.3)"
        : "1px solid rgba(100, 116, 139, 0.4)",
    background:
      theme === "light"
        ? "#f8fafc"
        : "rgba(15, 23, 42, 0.3)",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    fontSize: isMobile ? "14px" : "15px",
    outline: "none",
    transition: "all 0.2s ease",
    textAlign: "start",
    boxSizing: "border-box",
  },
  // Small numeric field (badge hide minutes). Not built on `input`: that
  // style's 44px icon padding on both sides left no room for the digits.
  numberInput: {
    width: "96px",
    padding: isMobile ? "12px 8px" : "10px 8px",
    borderRadius: "12px",
    border:
      theme === "light"
        ? "1px solid rgba(148, 163, 184, 0.5)"
        : "1px solid rgba(148, 163, 184, 0.45)",
    background: theme === "light" ? "#ffffff" : "rgba(15, 23, 42, 0.6)",
    color: theme === "light" ? "#0f172a" : "#f8fafc",
    fontSize: isMobile ? "15px" : "16px",
    fontWeight: 600,
    textAlign: "center",
    outline: "none",
    boxSizing: "border-box",
    // Renders the native spin arrows in the matching theme.
    colorScheme: theme === "light" ? "light" : "dark",
  },
  inputLeadIcon: {
    position: "absolute",
    insetInlineStart: "14px",
    color: theme === "light" ? "#94a3b8" : "rgba(255, 255, 255, 0.45)",
    display: "flex",
    alignItems: "center",
    pointerEvents: "none",
  },
  inputIcon: {
    position: "absolute",
    insetInlineEnd: "10px",
    background: "transparent",
    border: "none",
    borderRadius: "8px",
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px",
    outline: "none",
    transition: "background 0.2s ease, color 0.2s ease",
  },
  submitButton: {
    background: "linear-gradient(135deg, #2e7cba 0%, #1a5c8c 100%)",
    color: "#ffffff",
    border: "none",
    borderRadius: "12px",
    padding: isMobile ? "14px" : "12px 24px",
    fontWeight: "700",
    fontSize: isMobile ? "14px" : "15px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    marginTop: "12px",
    width: "100%",
  },
  errorMessage: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#ef4444",
    fontSize: "13px",
    fontWeight: "600",
    background: "rgba(239, 68, 68, 0.1)",
    border: "1px solid rgba(239, 68, 68, 0.25)",
    borderRadius: "12px",
    padding: "10px 14px",
    textAlign: "start",
  },
  successMessage: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#10b981",
    fontSize: "13px",
    fontWeight: "600",
    marginTop: "4px",
    textAlign: "start",
  },
});